    <!--#region vue BO mission + calculateur HORS CAC-->
<ng-container *ngIf="calculatorService?.Mission?.BoName != 'BO_MCAC' else modeCAC">
  <ng-container *ngIf="calculatorService?.Mission?.globalInformationGroup">
    <ng-container *ngTemplateOutlet="GroupView; context:{group:calculatorService.Mission.globalInformationGroup, isGlobal:true, index:-1}"></ng-container>
  </ng-container>

  <ng-container *ngFor="let group of calculatorService?.Mission?.Groups; let iGroup = index">
    <ng-container *ngIf="group?.ShowCalculGroup">
      <ng-container *ngTemplateOutlet="GroupView; context:{group:group, index:iGroup, isGlobal:false}">
      </ng-container>
    </ng-container>
  </ng-container>
</ng-container>
<!--#endregion-->
<!--#region calculateur CAC-->
<ng-template #modeCAC>
  <ng-container *ngIf="calculatorService.Mission?.Cacs">
    <div class="col-12 mission-group">
      <div class="row">
        <div class="col-12 d-flex py-1">
          <span class="col-auto d-flex align-items-center q-bold pr-1">Répartition des heures</span>
          <div>{{getFourchetteHeure()}}</div>
        </div>
      </div>
      <div class="row mission-question mx-0 mb-3 overflow-auto">
        <div class="col-12">
          <div class="row">
            <table class="table-cac-detail ml-3 mt-3">
              <thead>
                <tr>
                  <th colspan="2" rowspan="2"></th>
                  <th>Signataire</th>
                  <th>Responsable Mission</th>
                  <th>Assistant Confirmé</th>
                  <th>Assistant débutant</th>
                  <th rowspan="2"></th>
                </tr>
                <tr>
                  <th><input type="number" step="any" class="q-input-border" [(ngModel)]="calculatorService.Mission.Cacs.UnitPriceSI" (focus)="ShowCacSaveButton()"/></th>
                  <th><input type="number" step="any" class="q-input-border" [(ngModel)]="calculatorService.Mission.Cacs.UnitPriceRM" (focus)="ShowCacSaveButton()"/></th>
                  <th><input type="number" step="any" class="q-input-border" [(ngModel)]="calculatorService.Mission.Cacs.UnitPriceSN" (focus)="ShowCacSaveButton()"/></th>
                  <th><input type="number" step="any" class="q-input-border" [(ngModel)]="calculatorService.Mission.Cacs.UnitPriceJN" (focus)="ShowCacSaveButton()"/></th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Etape</td>
                  <td>Total (h)</td>
                  <td>Signataire</td>
                  <td>Responsable Mission</td>
                  <td>Assistant Confirmé</td>
                  <td>Assistant débutant</td>
                  <td>Equilibre</td>
                </tr>
                <tr *ngFor="let row of calculatorService.Mission?.Cacs?.Values" class="tr-content"
                    [ngClass]="{'q-danger': row.MissionHours - (row.HoursSI + row.HoursRM + row.HoursSN + row.HoursJN) < 0,'q-warning': row.MissionHours - (row.HoursSI + row.HoursRM + row.HoursSN + row.HoursJN) > 0}">
                  <td>{{row.Label}}</td>
                  <td><input type="number" step="any" class="q-input-border m-0" [(ngModel)]="row.MissionHours" (focus)="ShowCacSaveButton()" (blur)="OnSaveMissionHour(row.Label, row.MissionHours)" /></td>
                  <td><input type="number" step="any" class="q-input-border m-0" [(ngModel)]="row.HoursSI" (focus)="ShowCacSaveButton()"/></td>
                  <td><input type="number" step="any" class="q-input-border m-0" [(ngModel)]="row.HoursRM" (focus)="ShowCacSaveButton()"/></td>
                  <td><input type="number" step="any" class="q-input-border m-0" [(ngModel)]="row.HoursSN" (focus)="ShowCacSaveButton()"/></td>
                  <td><input type="number" step="any" class="q-input-border m-0" [(ngModel)]="row.HoursJN" (focus)="ShowCacSaveButton()"/></td>
                  <td [ngClass]="{'q-c-main' : row.MissionHours - (row.HoursSI + row.HoursRM + row.HoursSN + row.HoursJN) === 0}">{{row.MissionHours - (row.HoursSI + row.HoursRM + row.HoursSN + row.HoursJN)}}</td>
                </tr>
                <tr>
                <tr>
                  <td></td>
                  <td><div>{{SumCacHours('MissionHours')}}</div></td>
                  <td><div>{{SumCacHours('HoursSI') * calculatorService.Mission.Cacs.UnitPriceSI}}</div></td>
                  <td><div>{{SumCacHours('HoursRM') * calculatorService.Mission.Cacs.UnitPriceRM}}</div></td>
                  <td><div>{{SumCacHours('HoursSN') * calculatorService.Mission.Cacs.UnitPriceSN}}</div></td>
                  <td><div>{{SumCacHours('HoursJN') * calculatorService.Mission.Cacs.UnitPriceJN}}</div></td>
                  <td></td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="col-12">
          <div class="row">
            <table class="ml-auto m-3 table-cac-recap">
              <tbody>
                <tr>
                  <th>Total</th>
                  <th>
                    {{(SumCacHours('HoursSI') * calculatorService.Mission.Cacs.UnitPriceSI) + (SumCacHours('HoursRM') * calculatorService.Mission.Cacs.UnitPriceRM) + (SumCacHours('HoursSN') * calculatorService.Mission.Cacs.UnitPriceSN) + (SumCacHours('HoursJN') * calculatorService.Mission.Cacs.UnitPriceJN)| money}}
                  </th>
                </tr>
                <tr>
                  <td>Remise</td>
                  <td><input type="number" step="any" class="q-input-border col-12 m-0" [(ngModel)]="calculatorService.Mission.Cacs.Discount" (focus)="ShowCacSaveButton()"/></td>
                </tr>
                <tr>
                  <td>Prix HT</td>
                  <td><div class="w-100 rounded-button q-dark-secondary">{{((SumCacHours('HoursSI') * calculatorService.Mission.Cacs.UnitPriceSI) + (SumCacHours('HoursRM') * calculatorService.Mission.Cacs.UnitPriceRM) + (SumCacHours('HoursSN') * calculatorService.Mission.Cacs.UnitPriceSN) + (SumCacHours('HoursJN') * calculatorService.Mission.Cacs.UnitPriceJN)) - calculatorService.Mission.Cacs.Discount| money}}</div></td>
                </tr>
                <tr>
                  <td></td>
                  <td *ngIf="calculatorService.showCacSaveButton"><button class="w-100 rounded-button q-success" (click)="OnSaveCAC() ; OnSaveDiscout()" (focus)="ShowCacSaveButton()"> <i [ngClass]="[calculatorService.Mission.loadingDatas ? 'fas fa-pulse fa-spinner fa-spin' : 'fas fa-save']"></i>Enregistrer</button></td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </ng-container>
</ng-template>
<!--#endregion-->
<!--#region TEMPLATE BO mission + calculateur HORS CAC-->
<ng-template #GroupView let-group="group" let-iGroup="index" let-isGlobal="isGlobal">
  <div class="row mission-group position-relative" [ngClass]="{'group-locked': group.locked, 'closed': !group.Visible}">
    <div class="col-12 d-flex py-1">

      <i *ngIf="!isGlobal && !group.Visible" class="far fa-plus-square q-c-danger q-pointer d-flex align-items-center"
         [attr.data-toggle]=" group.Visible ? true : 'collapse'" [attr.data-target]="'#collapse' + iGroup"
         aria-expanded="true" [attr.aria-controls]="'#collapse' + iGroup"
         (click)="calculatorService.ToggleGroup(group, true);"></i>
      <i *ngIf="!isGlobal && group.Visible" class="far fa-minus-square q-c-success q-pointer d-flex align-items-center"
         [attr.data-toggle]=" group.Visible ? 'collapse' : false" [attr.data-target]="'#collapse' + iGroup"
         aria-expanded="true" [attr.aria-controls]="'#collapse' + iGroup"
         (click)="calculatorService.ToggleGroup(group, false);"></i>

      <div class="align-items-center q-bold title-container">
        <span [title]="group.Label">{{group.Label}}</span>
        <span class="q-c-primary col-auto px-1 title-info-circle" *ngIf="group.Description" [title]="group.Description"><i class="fas fa-info-circle"></i></span>
      </div>
    </div>

    <div *ngIf="!group.Visible" style="position: absolute; top: 4px; right: 45px; width: 250px;" class="d-flex calcul-scroller">
      <div class="col-label-total px-1">
        <button *ngIf="group.Discount || group.Visible"
                class="w-100 rounded-button q-light-secondary"
                title="Remises">
          {{group.Discount | money}}
        </button>
      </div>
      <div class="col-label-total pl-1 pr-2">
        <button *ngIf="group.Amount || group.Visible"
                class="w-100 rounded-button q-dark-secondary justify-content-end"
                title="Totaux">
          {{group.Amount | money}}
        </button>
      </div>
      <div class="col-label-button px-1"></div>
    </div>
    <div class="col-12" [ngClass]="{'calcul-scroller': group.Visible}">
      <div [ngClass]="{'calcul-scroll-container': group.Visible}">
        <div [ngClass]="[group.Visible ? 'calcul-table-size': 'row']">
          <div [id]="'collapse' + iGroup" class="mission-question mx-3 collapse mt-2 mb-3" [ngClass]="[group.Visible || isGlobal ? 'show': '', group.Visible? 'w-100': 'col']">
            <table class="w-100 pt-2" style="font-size: 0.8rem;">
              <thead class="q-bold mt-2">
                <tr>
                  <th class="px-1 col-label-obli pr-3 position-relative">Obligation</th>
                  <th class="col-label-collabo px-1">Collaborateur</th>
                  <th class="col-label-type px-1"></th>
                  <th class="col-label-tarifs px-1 th-centered" title="Durée">Durée</th>
                  <th class="col-label-tarifs px-1 th-centered" title="Prix horaire" style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">Prix horaire</th>
                  <th class="col-label-tarifs px-1 th-centered" title="Quantité">Qté</th>
                  <th class="col-label-tarifs px-1 th-centered" title="Prix unitaire" style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">Prix unitaire</th>
                  <th class="col-label-total pl-2 pr-3 th-centered">Remise</th>
                  <th class="col-label-total px-1 pr-3 th-end">Total</th>
                  <th class="col-label-button px-1"></th>
                </tr>
              </thead>
            </table>

            <ng-container *ngFor="let question of group.Questions; let iQuestion = index; let last = last">
              <ng-container *ngIf="question.ShowCalculQuestion || (isGlobal && iQuestion == 0)">
                <div [ngClass]="[group.Visible ? 'w-100': 'row']">
                  <table class="w-100" style="font-size: 0.8rem;">
                    <tbody>
                      <ng-container *ngIf="isGlobal && iQuestion == 0">
                        <ng-container *ngTemplateOutlet="calculTemplate; context:{obli:NewObligationLine, iObli:0}"></ng-container>
                      </ng-container>

                      <ng-container *ngFor="let obli of question.Obligations; let iObli = index">
                        <ng-container *ngIf="obli.isPdc">
                          <ng-container *ngTemplateOutlet="calculTemplate; context:{obli:obli, iObli:iObli}"></ng-container>
                        </ng-container>
                        <!--<ng-container *ngTemplateOutlet="calculTemplate; context:{obli:obli, iObli:iObli}"></ng-container>-->
                      </ng-container>

                      <ng-template #calculTemplate let-obli="obli" let-iObli="iObli" let-questLabel>
                        <tr class="px-1">
                          <!--#region code Obligation-->
                          <td class="px-1 col-label-obli pr-3 position-relative" [title]="isGlobal && iQuestion == 0 ? '' : question.Label + ' - ' + obli?.Code + ' - ' + obli?.Label">
                            <input *ngIf="isGlobal && iQuestion == 0 else LabelObligation" type="text" [(ngModel)]="obli.Label" placeholder="libellé"
                                   class="m-0 q-input-border w-100"
                                   [ngClass]="{'q-danger' : obli.EmptyLabel}"
                                   (blur)="obli.EmptyLabel = false;" />
                            <ng-template #LabelObligation>

                              <ng-container *ngIf="calculatorService.displayConfigObligationButtons && obli.Values && obli.Values.length > 0">
                                <span>
                                  <button style="max-height: 30px;"
                                          class="q-btn q-white" [title]="obli.Values[0].Info + ' ( ' + obli.Values[0].Code + ' )'"
                                          (click)="OpenModalCondition($event, obli);">
                                    <i class="fas fa-external-link-alt"></i>
                                  </button>
                                </span>
                              </ng-container>

                              <span [ngClass]="{'q-c-danger': (!isGlobal || iQuestion === 2) && obli.Valide != '1'}" class="q-bold">{{obli?.Label}}</span>
                            </ng-template>

                            <span class="q-c-primary col-auto d-flex" *ngIf="obli.Description" [title]="obli.Description" style="position: absolute; right: 0;">
                              <i class="fas fa-info-circle"></i>
                            </span>
                          </td>
                          <!--#endregion code Obligation-->
                          <!--#region select collaborateur-->
                          <td class="col-label-collabo px-1">
                            <select class="q-main-select w-100 m-0 p-0" style="min-width: 200px;" [ngClass]="{'q-danger' : obli.EmptyCollaborateur}"
                                    [(ngModel)]="obli.Collaborateur" (change)="obli.EmptyCollaborateur = false; OnCollaboChange( $event.target.value,obli, question, group, isGlobal && iQuestion == 0);">
                              <option *ngFor="let collabo of calculatorService.Collaborateurs" [value]="collabo.id">{{collabo.value}} - {{collabo.Cout}} €/h</option>
                            </select>
                          </td>
                          <!--#endregion-->
                          <!--#region switch temps forfait-->
                          <td class="px-1 col-label-type">
                            <div class="w-100 d-flex align-items-center">
                              <p class="col-auto p-0 m-0">Temps</p>
                              <input class="col-auto p-0 m-0 ml-2 switch" [ngClass]="[obli.EmptyBillingMethod ? 'error' : obli.BillingMethod == 'FOR'? 'rigth' :  obli.BillingMethod == 'TPS'? 'left' : 'middle']" type="range" name="points" min="1" max="3" [ngModel]="BillingMethodToRange(obli.BillingMethod)" (ngModelChange)="obli.EmptyBillingMethod = false; RangeToBillingMethod($event, obli, question, group, isGlobal && iQuestion == 0)">
                              <p class="col-auto p-0 m-0 ml-2">Forfait</p>
                            </div>
                          </td>
                          <!--#endregion temps forfait-->
                          <!--#region input Durée-->
                          <td class="px-1 col-label-tarifs">
                            <input type="number" class="w-100 q-input-border mb-0" [(ngModel)]="obli.Duration"
                                   [ngClass]="{'q-danger' : obli.EmptyDuration}"
                                   (blur)="obli.EmptyDuration = false; UpdateAmount(obli, question, group, isGlobal && iQuestion == 0)" />
                          </td>
                          <!--#endregion input Durée-->
                          <!--#region input Prix horaire-->
                          <td class="px-1 col-label-tarifs">
                            <input type="number" class="w-100 q-input-border mb-0" [disabled]="obli.BillingMethod !== 'TPS'" [(ngModel)]="obli.DurationPrice"
                                   [ngClass]="{'q-danger' : obli.EmptyDurationPrice}"
                                   (blur)="obli.EmptyDurationPrice = false; UpdateAmount(obli, question, group, isGlobal && iQuestion == 0)" />
                          </td>
                          <!--#endregion input Prix horaire-->
                          <!--#region input Quantité-->
                          <td class="px-1 col-label-tarifs">
                            <input type="number" class="w-100 q-input-border mb-0" [disabled]="obli.BillingMethod !== 'FOR'" [(ngModel)]="obli.Quantity"
                                   [ngClass]="{'q-danger' : obli.EmptyQuantity}"
                                   (blur)="obli.EmptyQuantity = false; UpdateAmount(obli, question, group, isGlobal && iQuestion == 0)" />
                          </td>
                          <!--#endregion input Quantité-->
                          <!--#region input Prix Quantité-->
                          <td class="px-1 col-label-tarifs">
                            <input type="number" class="w-100 q-input-border mb-0" [disabled]="obli.BillingMethod !== 'FOR'" [(ngModel)]="obli.QuantityPrice"
                                   [ngClass]="{'q-danger' : obli.EmptyQuantityPrice}"
                                   (blur)="obli.EmptyQuantityPrice = false; UpdateAmount(obli, question, group, isGlobal && iQuestion == 0)" />
                          </td>
                          <!--#endregion input Prix Quantité-->
                          <!--#region input Remise-->
                          <td class="px-1 col-label-total">
                            <input type="number" class="w-100 q-input-border mb-0" [disabled]="obli.BillingMethod !== 'FOR' && obli.BillingMethod !== 'TPS'" [(ngModel)]="obli.Discount" (blur)="DisplayGroupDiscount(group); UpdateAmount(obli, question, group, isGlobal && iQuestion == 0)" />
                          </td>
                          <!--#endregion input Remise-->
                          <!--#region Total-->
                          <td class="col-label-total q-bold pl-2 pr-3">
                            {{obli.Amount | money}}
                          </td>
                          <td class="col-label-button q-bold pl-2 pr-3">
                            <ng-container *ngIf="isGlobal">
                              <button *ngIf="isGlobal && iQuestion == 0 && showSavingNewObligation"
                                      class="q-btn q-success col-auto ml-auto"
                                      title="Enregistrer la nouvelle obligation"
                                      (click)="OpenModaleSaveNewObligation()"
                                      [disabled]="savingNewObligation">
                                <i class="mr-1" [ngClass]="[calculatorService.savingMission ? 'fas fa-pulse fa-spinner fa-spin' : 'fas fa-plus']"></i>Ajouter
                              </button>
                              <button *ngIf="obli.Deletable && iQuestion == 1"
                                      class="q-btn q-danger col-auto ml-auto"
                                      title="Supprimer l'obligation"
                                      (click)="OpenModaleDeleteFreeObligation(obli, iObli)"
                                      [disabled]="obli.Deleting">
                                <i class="mr-1" [ngClass]="[obli.Deleting ? 'fas fa-pulse fa-spinner fa-spin' : 'fas fa-trash']"></i>Supprimer
                              </button>
                            </ng-container>
                          </td>
                          <!--#endregion Total-->
                          <!--#region Bouton sauvegarde nouvelle ligne manuelle-->
                          <!--#endregion Bouton sauvegarde nouvelle ligne manuelle-->
                        </tr>
                      </ng-template>
                    </tbody>
                  </table>
                </div>
              </ng-container>
            </ng-container>
            <table class="w-100 mb-2 pt-2" style="font-size: 0.8rem;">
              <tfoot class="q-bold mt-2">
                <tr>
                  <th class="px-1 col-label-obli pr-3 position-relative"></th>
                  <th class="col-label-collabo px-1"></th>
                  <th class="px-1 col-label-type"></th>
                  <th class="px-1 col-label-tarifs"></th>
                  <th class="px-1 col-label-tarifs"></th>
                  <th class="px-1 col-label-tarifs"></th>
                  <th class="px-1 col-label-tarifs"></th>
                  <th class="px-1 col-label-total">
                    <button *ngIf="group.Discount || group.Visible"
                            class="w-100 rounded-button q-light-secondary"
                            title="Remises">
                      {{group.Discount | money}}
                    </button>
                  </th>
                  <th class="col-label-total q-bold pl-2 pr-1">
                    <button *ngIf="group.Amount || group.Visible"
                            class="w-100 rounded-button q-dark-secondary justify-content-end"
                            title="Totaux">
                      {{group.Amount | money}}
                    </button>
                  </th>
                  <th class="col-label-button q-bold pl-2 pr-3"></th>
                </tr>
              </tfoot>
            </table>
          </div>
        </div>

      </div>
    </div>
  </div>
</ng-template>
<!--#endregion-->


<ng-template #ModalConfirmSaveFreeObligation let-modal>
  <div class="modal-body">
    <button type="button" class="close" aria-label="Close" (click)="modal.dismiss();">
      <span aria-hidden="true">&times;</span>
    </button>
    <div class=" row">
      <h5 class="col-12 q-c-main q-bold" style="text-align: center;">Enregistrement de l'obligation</h5>
      <h8 class="col-12 q-c-main q-bold" style="text-align: center;">Souhaitez-vous mettre à jour les montants de la mission?</h8>
    </div>
    <div class="row mt-4">
      <div class="col-6" style="justify-content: flex-end; display: flex;">
        <button class="q-btn q-main" title="Enregistrer l'obligation et mettre à jour les montants" (click)="SaveNewObligation(true);">
          <i class="fas fa-save mr-2"></i>Oui
        </button>
      </div>
      <div class="col-6" style="justify-content: flex-start; display: flex;">
        <button class="q-btn" title="Enregistrer l'obligation sans mettre à jour les montants" (click)="SaveNewObligation(false);">
          <i class="fas fa-save mr-2"></i>Non
        </button>
      </div>
    </div>
  </div>
</ng-template>


<ng-template #ModalConfirmDeleteFreeObligation let-modal>
  <div class="modal-body">
    <button type="button" class="close" aria-label="Close" (click)="modal.dismiss();">
      <span aria-hidden="true">&times;</span>
    </button>
    <div class="row">
      <h5 class="col-12 q-c-main q-bold" style="text-align: center;">Suppression de l'obligation</h5>
      <h8 class="col-12 q-c-main q-bold" style="text-align: center;">Souhaitez-vous mettre à jour les montants de la mission?</h8>
    </div>
    <div class="row mt-4">
      <div class="col-6" style="justify-content: flex-end; display: flex;">
        <button class="q-btn q-main" title="Supprimer l'obligation et mettre à jour les montants" (click)="DeleteFreeObligation(true);">
          <i class="fas fa-save mr-2"></i>Oui
        </button>
      </div>
      <div class="col-6" style="justify-content: flex-start; display: flex;">
        <button class="q-btn" title="Supprimer l'obligation sans mettre à jour les montants" (click)="DeleteFreeObligation(false);">
          <i class="fas fa-save mr-2"></i>Non
        </button>
      </div>
    </div>
  </div>
</ng-template>
